import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/68b07a875d3055b09220b188_logo_211f22cbce9336b3b4b67133df2ecdfd_1x.avif"
              alt="American Guard Services"
              className="h-8"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/')
                  ? isScrolled
                    ? 'text-primary-600'
                    : 'text-primary-400'
                  : isScrolled
                  ? 'text-dark-700 hover:text-primary-600'
                  : 'text-white hover:text-primary-400'
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/services')
                  ? isScrolled
                    ? 'text-primary-600'
                    : 'text-primary-400'
                  : isScrolled
                  ? 'text-dark-700 hover:text-primary-600'
                  : 'text-white hover:text-primary-400'
              }`}
            >
              Services
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? isScrolled
                    ? 'text-primary-600'
                    : 'text-primary-400'
                  : isScrolled
                  ? 'text-dark-700 hover:text-primary-600'
                  : 'text-white hover:text-primary-400'
              }`}
            >
              About
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/contact')
                  ? isScrolled
                    ? 'text-primary-600'
                    : 'text-primary-400'
                  : isScrolled
                  ? 'text-dark-700 hover:text-primary-600'
                  : 'text-white hover:text-primary-400'
              }`}
            >
              Contact
            </Link>
            <Link
              to="/contact"
              className="px-6 py-2.5 bg-primary-500 text-dark-900 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Request a Consultation
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2"
            aria-label="Toggle menu"
          >
            <i
              className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl ${
                isScrolled ? 'text-dark-900' : 'text-white'
              }`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-dark-200">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block px-4 py-2 rounded-lg text-sm font-medium ${
                isActive('/') ? 'bg-primary-50 text-primary-600' : 'text-dark-700'
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block px-4 py-2 rounded-lg text-sm font-medium ${
                isActive('/services') ? 'bg-primary-50 text-primary-600' : 'text-dark-700'
              }`}
            >
              Services
            </Link>
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block px-4 py-2 rounded-lg text-sm font-medium ${
                isActive('/about') ? 'bg-primary-50 text-primary-600' : 'text-dark-700'
              }`}
            >
              About
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block px-4 py-2 rounded-lg text-sm font-medium ${
                isActive('/contact') ? 'bg-primary-50 text-primary-600' : 'text-dark-700'
              }`}
            >
              Contact
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2.5 bg-primary-500 text-dark-900 rounded-lg text-sm font-semibold text-center whitespace-nowrap"
            >
              Request a Consultation
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;